import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { MobileDatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { convertToHTML } from "draft-convert";
import { EditorState } from "draft-js";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useContext } from "react";
import { useHistory, useParams } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../../../App";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";

const EditPendingFanGroup = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [value, setValue] = React.useState(new Date("2014-08-18T21:11:54"));
  const [dateValue, setDateValue] = useState(new Date());
  const [endDateValue, setEndDateValue] = useState(new Date());
  const [errorList, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  let { slug } = useParams();
  const history = useHistory();
  const [banner, setBanner] = useState("");
  const [showBanner, setShowBanner] = useState("");

  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'fangroup/images',delKey);

  const handleBanner = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const deleteFile = ()=>
  {
    setFile(null);
    setDelKey(fileKey);
    fileInputRef.current.value = '';
  }

  const [convertedContent, setConvertedContent] = useState(null);

  const [fanDetails, setFanDetails] = useState([]);
  const [group_name, setGroupName] = useState("");
  const [club_points, setClubPoints] = useState("");
  const [min_member, setMinMember] = useState("");
  const [max_member, setMaxMember] = useState("");



  useEffect(() => {
    axios.get(`/api/admin/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanDetails(res.data.fanDetails);
        setConvertedContent(res.data.fanDetails.description);
        setDateValue(res.data.fanDetails.start_date);
        setEndDateValue(res.data.fanDetails.end_date);
        setGroupName(res.data.fanDetails.group_name);
        setClubPoints(res.data.fanDetails.club_points);
        setMinMember(res.data.fanDetails.min_member);
        setMaxMember(res.data.fanDetails.max_member);
        setFilePath(res.data.fanDetails?.banner);
      }
    });
  }, [slug]);

  const updateFanGroup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setLoading(true);
    const formData = new FormData();

    formData.append("group_name", group_name);
    formData.append("club_points", club_points);
    formData.append("description", convertedContent);
    // formData.append('start_date', dateValue);
    // formData.append('end_date', endDateValue);
    formData.append(
      "start_date",
      moment(dateValue).format("yyyy-MM-DD HH:mm:ss")
    );
    formData.append(
      "end_date",
      moment(endDateValue).format("yyyy-MM-DD HH:mm:ss")
    );
    formData.append("min_member", min_member);
    formData.append("max_member", max_member);
    formData.append("banner", fileKey?fileKey:filePath);

    axios.post(`/api/admin/fan/group/update/${slug}`, formData).then((res) => {
      setLoading(false);
      if (res.data.status === 200) {
        setError([]);
        if(file){
          setFile('');
          setDelKey(filePath.split("com/").pop())
        }
        swal("Welcome", res.data.message, "success");
        history.push("/superstar-admin/fan-group");
      } else {
        setError(res.data.validation_errors);
      }
    });
  };

  return (
    <div className="AS">
      <div className="card card-bg head-line mb-2 mb-3">
        <div className="text-light d-flex justify-content-center p-2">
          <div className="faTrophy">
            <i className="fas fa-trophy"></i>
          </div>
          <h4 className="mx-3 text-white px-2 pb-2 pt-2">Create Fan Group</h4>
        </div>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form onSubmit={updateFanGroup}>
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Group Name</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        readOnly="readonly"
                        type="text"
                        value={group_name}
                        onChange={(event) => {
                          setGroupName(event.target.value);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.group_name}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Club Points</p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        value={club_points}
                        onChange={(event) => {
                          setClubPoints(event.target.value);
                        }}
                      />
                      <span className="text-danger">
                        {errorList.club_points}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>Group Motive</p>
                    </div>

                    <div className="col-md-9 ckedittor-fangroup">
                      <CKEditor
                        data={convertedContent}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setConvertedContent(editor.getData());
                        }}
                      />
                      <span className="text-danger">
                        {errorList.description}
                      </span>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Select Date</p>
                    </div>
                    <div className="col-md-9 row">
                      <div className="col-md-5 timeLengthPicker">
                        <input
                          type="date"
                          className="form-control reply-control"
                          onChange={(e) => setDateValue(e.target.value)}
                          name="date"
                          value={dateValue}
                        />
                        <span className="text-danger">
                          {errorList.start_date}
                        </span>
                      </div>
                      <div className="col-md-1 d-flex justify-content-center">
                        <span className="fw-bold text-light mt-3">To</span>
                      </div>
                      <div className="col-md-5 timeLengthPicker">
                        <input
                          type="date"
                          className="form-control reply-control"
                          onChange={(e) => setEndDateValue(e.target.value)}
                          name="date"
                          value={endDateValue}
                        />
                        <span className="text-danger">
                          {errorList.end_date}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text label-text">
                      <p>Members Limit</p>
                    </div>

                    <div className="col-md-9 row">
                      <div className="col-md-5">
                        <input
                          type="number"
                          className="form-control reply-control"
                          value={min_member}
                          onChange={(event) => {
                            setMinMember(event.target.value);
                          }}
                        />
                        <span className="text-danger">
                          {errorList.min_member}
                        </span>
                      </div>
                      <div className="col-md-1">
                        <span className="fw-bold text-light mt-3">To</span>
                      </div>
                      <div className="col-md-5">
                        <input
                          type="number"
                          className="form-control reply-control"
                          value={max_member}
                          onChange={(event) => {
                            setMaxMember(event.target.value);
                          }}
                        />
                        <span className="text-danger">
                          {errorList.max_member}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>Upload Banner</p>
                    </div>
                    <div className="col-md-4">
                      {fileUrl && file ? (
                          <div className="position-relative">
                            <img
                            src={fileUrl}
                            className="img-fluid avatar-img-src"
                            alt=""
                            style={{ maxHeight: "300px" }}
                          />  
                          <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                          </div>
                        ) : (
                          <img
                            src={imageCdnUrl + filePath}
                            className="img-fluid avatar-img-src"
                            alt=""
                            style={{ maxHeight: "300px" }}
                          />
                        )}
                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(e) => handleBanner(e.target.files)}
                        id="image"
                        name="image"
                        ref={fileInputRef}
                      />
                       {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                    </div>
                  </div>

                  {/* Update Submit */}
                  <div className="row justify-content-center aligns-items-center my-4 mt-5">
                    <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto d-flex justify-content-center aligns-items-center">
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnUpdate fw-bold" type="submit">
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update Submit End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPendingFanGroup;
